// Desplegamos los datos generales
import React from 'react'
import ShowGeneral from './ShowGeneral'

export default function ShowFull({show , disable , setClose }) {
  return (
    <div className='container'>
      <div className=' px-5' style={{borderWidth:'2',borderColor:'grey', 
      borderRadius:'5px' , borderStyle:'solid' }} >
        {/* <p>Status = {show.sku}</p> */}
        <ShowGeneral showProduct={show} disable={disable} setClose={setClose}></ShowGeneral> 
      </div>

    </div>
  )
}
